import React, { useEffect, useMemo } from "react"
import { ImageDataLike } from "gatsby-plugin-image"
import clsx from "clsx"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import { advantages } from "../../../FourAdvantagesPoints/helpers"

import { Img } from "./Img"

import * as styles from "./banner.module.scss"
import { handleClickBanner } from "../../../../helpers/WatcherDL"

type BannerProps = {
  large: ImageDataLike
  mob: ImageDataLike
  buttonText?: string
  title?: string
  description?: string
  orderNum?: string
  classes?: BannerClasses
  variantStyle?: "mebelor" | "halvaMedia"
  isAdvantages?: boolean
  advantagesData?: "refin"
}

type BannerClasses = {
  root?: string
  container?: string
  secondContainer?: string
  img?: string
  textContainer?: string
  heading?: string
  description?: string
  button?: string
  buttonBlock?: string
  buttonMob?: string
}

const defaultTitle = `
  <span>Карта «Халва»</span>
  <br/>
  24 месяца без % на&nbsp;все!
`

const defaultSubtext = `
  — До 17% на остаток по карте
  <br />
  — Кэшбэк до 10%
  <br />— Обслуживание 0 ₽
`

export function Banner({
  large,
  mob,
  buttonText = "Оформить карту",
  title = defaultTitle,
  description = defaultSubtext,
  orderNum,
  classes,
  variantStyle,
  isAdvantages = false,
  advantagesData,
}: BannerProps) {
  useEffect(() => {
    document.body.style.display = "block"
  }, [])

  const advantagesList = useMemo(() => {
    if (!advantagesData || !advantages[advantagesData]) {
      return []
    }

    return advantages[advantagesData].map(
      (item, idx) =>
        item.required && (
          <div key={idx} className={styles.textItem}>
            <div className={styles.title}>{item.title}</div>
            <div className={styles.subtitle}>{item.subtitle}</div>
          </div>
        )
    )
  }, [advantagesData])

  return (
    <>
      <section
        className={clsx(styles.section, classes?.root, variantStyle && styles[variantStyle])}
        data-exclude={orderNum}
      >
        <Container className={clsx(styles.container, classes?.container)}>
          <div className={clsx(styles.secondContainer, classes?.secondContainer)}>
            <Img
              alt="bg image"
              className={clsx(styles.img, classes?.img)}
              large={large}
              mob={mob}
            />
            <div className={clsx(styles.text, classes?.textContainer)}>
              <h1 className={clsx(classes?.heading)} dangerouslySetInnerHTML={{ __html: title }} />
              <div
                className={clsx(classes?.description)}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>
            <Button
              className={clsx(styles.btn, classes?.button)}
              onClick={() => handleClickBanner(buttonText, title)}
            >
              {buttonText}
            </Button>
          </div>
        </Container>
      </section>
      <div
        className={clsx(
          styles.btnBlock,
          isAdvantages && styles.btnBlockAdvantages,
          classes?.buttonBlock,
          variantStyle && styles[variantStyle]
        )}
      >
        {isAdvantages ? (
          <Container className={styles.textBlockContainer}>
            <div className={styles.wrapper}>
              <div className={styles.textBlock}>{advantagesList}</div>
              <Button
                onClick={() => handleClickBanner(buttonText, title)}
                className={clsx(styles.mobBtn, classes?.buttonMob)}
              >
                {buttonText}
              </Button>
            </div>
          </Container>
        ) : (
          <Container>
            <Button
              onClick={() => handleClickBanner(buttonText, title)}
              className={clsx(styles.mobBtn, classes?.buttonMob)}
            >
              {buttonText}
            </Button>
          </Container>
        )}
      </div>
    </>
  )
}
